// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
       
       /* started master design */
    
       .operator-container {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        justify-content: space-between; /* it will give space between header and footer */
        
      }
      
      .contentoperator {
        flex: 1 1;
        padding-bottom: 10px; /* Adjust as needed to leave space for the footer */
      }
      
      
      .operator-container {
        background-color: #eaeaeb; /*page background color*/
      }
        
        .contentoperator {
        display: flex;
        flex-direction: column;
        margin-left: 120px; /*PUSHING THE CARDS/*
        align-items: center;
        justify-content: flex-start; /* Adjust this to 'center' if you want content centered vertically */
        min-height: 40vh; /* Ensures the container takes at least the full viewport height */
        
      }
      .button {
        background-color: #ccc; /* Default background color */
        padding: 2px 20px; /* Adjust padding as needed */
        margin: 0 10px; /* Adjust margin as needed */
      }
      
      /* .active {
        background-color: #0099ff; 
        color: #fff; 
      } */
      
      .inactive {
        background-color: #25c7eb; /* Inactive button background color */
        color: #000; /* Inactive button text color */
      }
      
      .inline {
        display: flex;
        align-items: center;
      }
      
      .inline p {
        margin-right: 10px; /* Increase the margin-right for more space */
        margin-left: 10px; /* Increase the margin-right for more space */
        transition: color 0.3s ease; /* Smooth transition for color change */
      }
      
      .inline select {
        border: 1px solid #ccc; /* Add a border */
        padding: 8px; /* Add padding */
        transition: border-color 0.3s ease; /* Smooth transition for border color change */
      }
      
      
      /* Hover effect */
      .inline p:hover {
        color: blue; /* Change text color on hover */
      }
      
      .inline select:hover {
        border-color: blue; /* Change border color on hover */
      }
      
      .inactive:hover {
        background-color: rgb(0, 162, 255); /* Change text color on hover */
        color: black;
      }
      
      /* View default master data Styling for radio buttons */
      /* input[type="radio"] {
        margin-right: 15px; Add space between the radio button and label
        margin-left: 20px; Increase the margin-right for more space
        Hide the default radio button
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        Create custom radio button
        width: 15px;
        height: 15px;
        border-radius: 50%;
        border: 1.5px solid blue; Change the color of the radio button border
        outline: none; Remove the default focus outline
        cursor: pointer;
      }
      
      Styling for checked radio buttons
      input[type="radio"]:checked {
        background-color: rgb(255, 0, 93); Change the background color when checked
      } */
      
      
      /* Style for the labels of radio buttons */
      label {
        cursor: pointer; /* Change cursor to pointer on hover */
        margin-right: 10px; /* Add space between the labels */
        color: blue;
      }
      
      /* drop down design */
      .custom-dropdown select {
        appearance: none; /* Remove default arrow */
        background-color: rgb(255, 255, 255);
        padding: 7px 20px; /* Adjust padding as needed */
        border: 1px solid #cccccc;
        border-radius: 10px;
        cursor: pointer;
        width: 300px; /* Set width as needed */
      }
      
      /* Tick box */
      .checkbox-label {
        display: flex;
        /* align-items: left; */
        margin-top: 10px; /* Adjust margin as needed */
        margin-bottom: 10px; /* Adjust margin as needed */
       
      }
      
      .checkbox-label input[type="checkbox"] {
        margin-right: 15px; /* Adjust margin between checkbox and label */
        width: 20px; /* Adjust width of the checkbox */
        height: 20px; /* Adjust height of the checkbox */ 
      }
      
      .checkbox-label label {
        font-size: 14px; /* Adjust font size as needed */
        color: #971b1b; /* Adjust color as needed */
        cursor: pointer;
      }
      
      /* choose file desgin */
      .file-input {
        /* Adjust the appearance of the file input button */
        background-color: #4CAF50;
        color: rgb(255, 255, 255);
        padding: 10px 20px;
        border: none;
        border-radius: 5px;
        
      }
      
      .file-input:hover {
        /* Adjust hover effect */
        background-color: #4545a0;
        cursor: pointer;
      }
      
      /* ended master design */
    
           body {
    
                margin-top: 0px;
            }
    
            .card-margin {
                margin-bottom: 1.875rem;
                
            }
           
            .operator-container.card {
                border: 0;
                box-shadow: 0px 0px 10px 0px rgba(82, 63, 105, 0.1);
                -webkit-box-shadow: 0px 0px 10px 0px rgba(82, 63, 105, 0.1);
                -moz-box-shadow: 0px 0px 10px 0px rgba(82, 63, 105, 0.1);
                -ms-box-shadow: 0px 0px 10px 0px rgba(82, 63, 105, 0.1);
            }
    
            .operator-container .card {
                position: relative;
                display: flex;
                flex-direction: column;
                min-width: 0;
                word-wrap: break-word;
                background-color: #ffffff;
                background-clip: border-box;
                border: 1px solid #e6e4e9;
                border-radius: 8px;
            }
    
            .card card-header-operator .no-border {
                border: 0;
            }
             
        /* here we can adjust the header name left and right for first card*/
        .card .card-header-operator1 {
          background: none;
          padding: 0 4.4375rem;
          font-weight: 500;
          display: flex;
          align-items: center;
          min-height: 50px;
      }
            /* here we can adjust the header name left to right second card*/
            .card .card-header-operator {
                background: none;
                padding: 0 3.4375rem;
                font-weight: 400;
                display: flex;
                align-items: center;
                min-height: 50px;
            }
    
            .card-header-operator:first-child {
                border-radius: calc(8px - 1px) calc(8px - 1px) 0 0;
            }
            /* .card-title {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 140%;
            } */
            
            
            
            .widget-49 .widget-49-title-wrapper {
                display: flex;
                align-items: center;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-primary {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                /* background-color: #edf1fc; */
                width: 4rem;
                height: 4rem;
                border-radius: 50%;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-primary .widget-49-date-day {
                color: #4e73e5;
                font-weight: 500;
                font-size: 1.5rem;
                line-height: 1;
                
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-primary .widget-49-date-month {
                color: #4e73e5;
                line-height: 1;
                font-size: 1rem;
                text-transform: uppercase;
                
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-secondary {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                background-color: #fcfcfd;
                width: 4rem;
                height: 4rem;
                border-radius: 50%;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-secondary .widget-49-date-day {
                color: #dde1e9;
                font-weight: 500;
                font-size: 1.5rem;
                line-height: 1;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-secondary .widget-49-date-month {
                color: #dde1e9;
                line-height: 1;
                font-size: 1rem;
                text-transform: uppercase;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-success {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                background-color: #e8faf8;
                width: 4rem;
                height: 4rem;
                border-radius: 50%;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-success .widget-49-date-day {
                color: #17d1bd;
                font-weight: 500;
                font-size: 1.5rem;
                line-height: 1;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-success .widget-49-date-month {
                color: #17d1bd;
                line-height: 1;
                font-size: 1rem;
                text-transform: uppercase;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-info {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                background-color: #ebf7ff;
                width: 4rem;
                height: 4rem;
                border-radius: 50%;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-info .widget-49-date-day {
                color: #36afff;
                font-weight: 500;
                font-size: 1.5rem;
                line-height: 1;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-info .widget-49-date-month {
                color: #36afff;
                line-height: 1;
                font-size: 1rem;
                text-transform: uppercase;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-warning {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                /* background-color: floralwhite; */
                width: 4rem;
                height: 4rem;
                border-radius: 50%;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-warning .widget-49-date-day {
                color: #FFC868;
                font-weight: 500;
                font-size: 1.5rem;
                line-height: 1;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-warning .widget-49-date-month {
                color: #FFC868;
                line-height: 1;
                font-size: 1rem;
                text-transform: uppercase;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-danger {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                background-color: #feeeef;
                width: 4rem;
                height: 4rem;
                border-radius: 50%;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-danger .widget-49-date-day {
                color: #F95062;
                font-weight: 500;
                font-size: 1.5rem;
                line-height: 1;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-danger .widget-49-date-month {
                color: #F95062;
                line-height: 1;
                font-size: 1rem;
                text-transform: uppercase;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-light {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                background-color: #fefeff;
                width: 4rem;
                height: 4rem;
                border-radius: 50%;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-light .widget-49-date-day {
                color: #f7f9fa;
                font-weight: 500;
                font-size: 1.5rem;
                line-height: 1;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-light .widget-49-date-month {
                color: #f7f9fa;
                line-height: 1;
                font-size: 1rem;
                text-transform: uppercase;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-dark {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                background-color: #ebedee;
                width: 4rem;
                height: 4rem;
                border-radius: 50%;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-dark .widget-49-date-day {
                color: #394856;
                font-weight: 500;
                font-size: 1.5rem;
                line-height: 1;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-dark .widget-49-date-month {
                color: #394856;
                line-height: 1;
                font-size: 1rem;
                text-transform: uppercase;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-base {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                background-color: #f0fafb;
                width: 4rem;
                height: 4rem;
                border-radius: 50%;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-base .widget-49-date-day {
                color: #68CBD7;
                font-weight: 500;
                font-size: 1.5rem;
                line-height: 1;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-date-base .widget-49-date-month {
                color: #68CBD7;
                line-height: 1;
                font-size: 1rem;
                text-transform: uppercase;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-meeting-info {
                display: flex;
                flex-direction: column;
                margin-left: 1rem;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-meeting-info .widget-49-pro-title {
                color: #3c4142;
                font-size: 14px;
            }
    
            .widget-49 .widget-49-title-wrapper .widget-49-meeting-info .widget-49-meeting-time {
                color: #B1BAC5;
                font-size: 13px;
            }
    
            .widget-49 .widget-49-meeting-points {
                font-weight: 400;
                font-size: 13px;
                margin-top: .5rem;
            }
    
            .widget-49 .widget-49-meeting-points .widget-49-meeting-item {
                display: list-item;
                color: #727686;
            }
    
            .widget-49 .widget-49-meeting-points .widget-49-meeting-item span {
                margin-left: .5rem;
            }
    
            .widget-49 .widget-49-meeting-action {
                text-align: center;
            }
    
            .widget-49 .widget-49-meeting-action a {
                text-transform: uppercase;
            }
            
            button.btn.btn.btn-primary.btn-sm.btn-custom {
                background-color: chocolate;
                border: 1px solid chocolate;
            }
    
            .content-push {
                transition: margin-left 0.5s;
              }
              @media (min-width: 992px) {
                .content-push {
                  margin-left: 250px; /* Adjust as per your menu width */
                }
              }
        /* ====== */
       `, "",{"version":3,"sources":["webpack://./src/assets/css/Operators.css"],"names":[],"mappings":";;OAEO,0BAA0B;;OAE1B;QACC,aAAa;QACb,sBAAsB;QACtB,iBAAiB;QACjB,8BAA8B,EAAE,iDAAiD;;MAEnF;;MAEA;QACE,SAAO;QACP,oBAAoB,EAAE,mDAAmD;MAC3E;;;MAGA;QACE,yBAAyB,EAAE,wBAAwB;MACrD;;QAEE;QACA,aAAa;QACb,sBAAsB;QACtB,kBAAkB,EAAE;;yGAE6E;QACjG,gBAAgB,EAAE,kEAAkE;;MAEtF;MACA;QACE,sBAAsB,EAAE,6BAA6B;QACrD,iBAAiB,EAAE,6BAA6B;QAChD,cAAc,EAAE,4BAA4B;MAC9C;;MAEA;;;SAGG;;MAEH;QACE,yBAAyB,EAAE,qCAAqC;QAChE,WAAW,EAAE,+BAA+B;MAC9C;;MAEA;QACE,aAAa;QACb,mBAAmB;MACrB;;MAEA;QACE,kBAAkB,EAAE,6CAA6C;QACjE,iBAAiB,EAAE,6CAA6C;QAChE,2BAA2B,EAAE,uCAAuC;MACtE;;MAEA;QACE,sBAAsB,EAAE,iBAAiB;QACzC,YAAY,EAAE,gBAAgB;QAC9B,kCAAkC,EAAE,8CAA8C;MACpF;;;MAGA,iBAAiB;MACjB;QACE,WAAW,EAAE,+BAA+B;MAC9C;;MAEA;QACE,kBAAkB,EAAE,iCAAiC;MACvD;;MAEA;QACE,kCAAkC,EAAE,+BAA+B;QACnE,YAAY;MACd;;MAEA,uDAAuD;MACvD;;;;;;;;;;;;;;;;;;;SAmBG;;;MAGH,0CAA0C;MAC1C;QACE,eAAe,EAAE,sCAAsC;QACvD,kBAAkB,EAAE,iCAAiC;QACrD,WAAW;MACb;;MAEA,qBAAqB;MACrB;QACE,gBAAgB,EAAE,yBAAyB;QAC3C,oCAAoC;QACpC,iBAAiB,EAAE,6BAA6B;QAChD,yBAAyB;QACzB,mBAAmB;QACnB,eAAe;QACf,YAAY,EAAE,wBAAwB;MACxC;;MAEA,aAAa;MACb;QACE,aAAa;QACb,uBAAuB;QACvB,gBAAgB,EAAE,4BAA4B;QAC9C,mBAAmB,EAAE,4BAA4B;;MAEnD;;MAEA;QACE,kBAAkB,EAAE,6CAA6C;QACjE,WAAW,EAAE,iCAAiC;QAC9C,YAAY,EAAE,kCAAkC;MAClD;;MAEA;QACE,eAAe,EAAE,+BAA+B;QAChD,cAAc,EAAE,2BAA2B;QAC3C,eAAe;MACjB;;MAEA,uBAAuB;MACvB;QACE,mDAAmD;QACnD,yBAAyB;QACzB,yBAAyB;QACzB,kBAAkB;QAClB,YAAY;QACZ,kBAAkB;;MAEpB;;MAEA;QACE,wBAAwB;QACxB,yBAAyB;QACzB,eAAe;MACjB;;MAEA,wBAAwB;;WAEnB;;gBAEK,eAAe;YACnB;;YAEA;gBACI,uBAAuB;;YAE3B;;YAEA;gBACI,SAAS;gBACT,mDAAmD;gBACnD,2DAA2D;gBAC3D,wDAAwD;gBACxD,uDAAuD;YAC3D;;YAEA;gBACI,kBAAkB;gBAClB,aAAa;gBACb,sBAAsB;gBACtB,YAAY;gBACZ,qBAAqB;gBACrB,yBAAyB;gBACzB,2BAA2B;gBAC3B,yBAAyB;gBACzB,kBAAkB;YACtB;;YAEA;gBACI,SAAS;YACb;;QAEJ,oEAAoE;QACpE;UACE,gBAAgB;UAChB,oBAAoB;UACpB,gBAAgB;UAChB,aAAa;UACb,mBAAmB;UACnB,gBAAgB;MACpB;YACM,gEAAgE;YAChE;gBACI,gBAAgB;gBAChB,oBAAoB;gBACpB,gBAAgB;gBAChB,aAAa;gBACb,mBAAmB;gBACnB,gBAAgB;YACpB;;YAEA;gBACI,kDAAkD;YACtD;YACA;;;;;eAKG;;;;YAIH;gBACI,aAAa;gBACb,mBAAmB;YACvB;;YAEA;gBACI,aAAa;gBACb,mBAAmB;gBACnB,uBAAuB;gBACvB,sBAAsB;gBACtB,+BAA+B;gBAC/B,WAAW;gBACX,YAAY;gBACZ,kBAAkB;YACtB;;YAEA;gBACI,cAAc;gBACd,gBAAgB;gBAChB,iBAAiB;gBACjB,cAAc;;YAElB;;YAEA;gBACI,cAAc;gBACd,cAAc;gBACd,eAAe;gBACf,yBAAyB;;YAE7B;;YAEA;gBACI,aAAa;gBACb,mBAAmB;gBACnB,uBAAuB;gBACvB,sBAAsB;gBACtB,yBAAyB;gBACzB,WAAW;gBACX,YAAY;gBACZ,kBAAkB;YACtB;;YAEA;gBACI,cAAc;gBACd,gBAAgB;gBAChB,iBAAiB;gBACjB,cAAc;YAClB;;YAEA;gBACI,cAAc;gBACd,cAAc;gBACd,eAAe;gBACf,yBAAyB;YAC7B;;YAEA;gBACI,aAAa;gBACb,mBAAmB;gBACnB,uBAAuB;gBACvB,sBAAsB;gBACtB,yBAAyB;gBACzB,WAAW;gBACX,YAAY;gBACZ,kBAAkB;YACtB;;YAEA;gBACI,cAAc;gBACd,gBAAgB;gBAChB,iBAAiB;gBACjB,cAAc;YAClB;;YAEA;gBACI,cAAc;gBACd,cAAc;gBACd,eAAe;gBACf,yBAAyB;YAC7B;;YAEA;gBACI,aAAa;gBACb,mBAAmB;gBACnB,uBAAuB;gBACvB,sBAAsB;gBACtB,yBAAyB;gBACzB,WAAW;gBACX,YAAY;gBACZ,kBAAkB;YACtB;;YAEA;gBACI,cAAc;gBACd,gBAAgB;gBAChB,iBAAiB;gBACjB,cAAc;YAClB;;YAEA;gBACI,cAAc;gBACd,cAAc;gBACd,eAAe;gBACf,yBAAyB;YAC7B;;YAEA;gBACI,aAAa;gBACb,mBAAmB;gBACnB,uBAAuB;gBACvB,sBAAsB;gBACtB,mCAAmC;gBACnC,WAAW;gBACX,YAAY;gBACZ,kBAAkB;YACtB;;YAEA;gBACI,cAAc;gBACd,gBAAgB;gBAChB,iBAAiB;gBACjB,cAAc;YAClB;;YAEA;gBACI,cAAc;gBACd,cAAc;gBACd,eAAe;gBACf,yBAAyB;YAC7B;;YAEA;gBACI,aAAa;gBACb,mBAAmB;gBACnB,uBAAuB;gBACvB,sBAAsB;gBACtB,yBAAyB;gBACzB,WAAW;gBACX,YAAY;gBACZ,kBAAkB;YACtB;;YAEA;gBACI,cAAc;gBACd,gBAAgB;gBAChB,iBAAiB;gBACjB,cAAc;YAClB;;YAEA;gBACI,cAAc;gBACd,cAAc;gBACd,eAAe;gBACf,yBAAyB;YAC7B;;YAEA;gBACI,aAAa;gBACb,mBAAmB;gBACnB,uBAAuB;gBACvB,sBAAsB;gBACtB,yBAAyB;gBACzB,WAAW;gBACX,YAAY;gBACZ,kBAAkB;YACtB;;YAEA;gBACI,cAAc;gBACd,gBAAgB;gBAChB,iBAAiB;gBACjB,cAAc;YAClB;;YAEA;gBACI,cAAc;gBACd,cAAc;gBACd,eAAe;gBACf,yBAAyB;YAC7B;;YAEA;gBACI,aAAa;gBACb,mBAAmB;gBACnB,uBAAuB;gBACvB,sBAAsB;gBACtB,yBAAyB;gBACzB,WAAW;gBACX,YAAY;gBACZ,kBAAkB;YACtB;;YAEA;gBACI,cAAc;gBACd,gBAAgB;gBAChB,iBAAiB;gBACjB,cAAc;YAClB;;YAEA;gBACI,cAAc;gBACd,cAAc;gBACd,eAAe;gBACf,yBAAyB;YAC7B;;YAEA;gBACI,aAAa;gBACb,mBAAmB;gBACnB,uBAAuB;gBACvB,sBAAsB;gBACtB,yBAAyB;gBACzB,WAAW;gBACX,YAAY;gBACZ,kBAAkB;YACtB;;YAEA;gBACI,cAAc;gBACd,gBAAgB;gBAChB,iBAAiB;gBACjB,cAAc;YAClB;;YAEA;gBACI,cAAc;gBACd,cAAc;gBACd,eAAe;gBACf,yBAAyB;YAC7B;;YAEA;gBACI,aAAa;gBACb,sBAAsB;gBACtB,iBAAiB;YACrB;;YAEA;gBACI,cAAc;gBACd,eAAe;YACnB;;YAEA;gBACI,cAAc;gBACd,eAAe;YACnB;;YAEA;gBACI,gBAAgB;gBAChB,eAAe;gBACf,iBAAiB;YACrB;;YAEA;gBACI,kBAAkB;gBAClB,cAAc;YAClB;;YAEA;gBACI,kBAAkB;YACtB;;YAEA;gBACI,kBAAkB;YACtB;;YAEA;gBACI,yBAAyB;YAC7B;;YAEA;gBACI,2BAA2B;gBAC3B,2BAA2B;YAC/B;;YAEA;gBACI,4BAA4B;cAC9B;cACA;gBACE;kBACE,kBAAkB,EAAE,kCAAkC;gBACxD;cACF;QACN,WAAW","sourcesContent":["\r\n       \r\n       /* started master design */\r\n    \r\n       .operator-container {\r\n        display: flex;\r\n        flex-direction: column;\r\n        min-height: 100vh;\r\n        justify-content: space-between; /* it will give space between header and footer */\r\n        \r\n      }\r\n      \r\n      .contentoperator {\r\n        flex: 1;\r\n        padding-bottom: 10px; /* Adjust as needed to leave space for the footer */\r\n      }\r\n      \r\n      \r\n      .operator-container {\r\n        background-color: #eaeaeb; /*page background color*/\r\n      }\r\n        \r\n        .contentoperator {\r\n        display: flex;\r\n        flex-direction: column;\r\n        margin-left: 120px; /*PUSHING THE CARDS/*\r\n        align-items: center;\r\n        justify-content: flex-start; /* Adjust this to 'center' if you want content centered vertically */\r\n        min-height: 40vh; /* Ensures the container takes at least the full viewport height */\r\n        \r\n      }\r\n      .button {\r\n        background-color: #ccc; /* Default background color */\r\n        padding: 2px 20px; /* Adjust padding as needed */\r\n        margin: 0 10px; /* Adjust margin as needed */\r\n      }\r\n      \r\n      /* .active {\r\n        background-color: #0099ff; \r\n        color: #fff; \r\n      } */\r\n      \r\n      .inactive {\r\n        background-color: #25c7eb; /* Inactive button background color */\r\n        color: #000; /* Inactive button text color */\r\n      }\r\n      \r\n      .inline {\r\n        display: flex;\r\n        align-items: center;\r\n      }\r\n      \r\n      .inline p {\r\n        margin-right: 10px; /* Increase the margin-right for more space */\r\n        margin-left: 10px; /* Increase the margin-right for more space */\r\n        transition: color 0.3s ease; /* Smooth transition for color change */\r\n      }\r\n      \r\n      .inline select {\r\n        border: 1px solid #ccc; /* Add a border */\r\n        padding: 8px; /* Add padding */\r\n        transition: border-color 0.3s ease; /* Smooth transition for border color change */\r\n      }\r\n      \r\n      \r\n      /* Hover effect */\r\n      .inline p:hover {\r\n        color: blue; /* Change text color on hover */\r\n      }\r\n      \r\n      .inline select:hover {\r\n        border-color: blue; /* Change border color on hover */\r\n      }\r\n      \r\n      .inactive:hover {\r\n        background-color: rgb(0, 162, 255); /* Change text color on hover */\r\n        color: black;\r\n      }\r\n      \r\n      /* View default master data Styling for radio buttons */\r\n      /* input[type=\"radio\"] {\r\n        margin-right: 15px; Add space between the radio button and label\r\n        margin-left: 20px; Increase the margin-right for more space\r\n        Hide the default radio button\r\n        appearance: none;\r\n        -webkit-appearance: none;\r\n        -moz-appearance: none;\r\n        Create custom radio button\r\n        width: 15px;\r\n        height: 15px;\r\n        border-radius: 50%;\r\n        border: 1.5px solid blue; Change the color of the radio button border\r\n        outline: none; Remove the default focus outline\r\n        cursor: pointer;\r\n      }\r\n      \r\n      Styling for checked radio buttons\r\n      input[type=\"radio\"]:checked {\r\n        background-color: rgb(255, 0, 93); Change the background color when checked\r\n      } */\r\n      \r\n      \r\n      /* Style for the labels of radio buttons */\r\n      label {\r\n        cursor: pointer; /* Change cursor to pointer on hover */\r\n        margin-right: 10px; /* Add space between the labels */\r\n        color: blue;\r\n      }\r\n      \r\n      /* drop down design */\r\n      .custom-dropdown select {\r\n        appearance: none; /* Remove default arrow */\r\n        background-color: rgb(255, 255, 255);\r\n        padding: 7px 20px; /* Adjust padding as needed */\r\n        border: 1px solid #cccccc;\r\n        border-radius: 10px;\r\n        cursor: pointer;\r\n        width: 300px; /* Set width as needed */\r\n      }\r\n      \r\n      /* Tick box */\r\n      .checkbox-label {\r\n        display: flex;\r\n        /* align-items: left; */\r\n        margin-top: 10px; /* Adjust margin as needed */\r\n        margin-bottom: 10px; /* Adjust margin as needed */\r\n       \r\n      }\r\n      \r\n      .checkbox-label input[type=\"checkbox\"] {\r\n        margin-right: 15px; /* Adjust margin between checkbox and label */\r\n        width: 20px; /* Adjust width of the checkbox */\r\n        height: 20px; /* Adjust height of the checkbox */ \r\n      }\r\n      \r\n      .checkbox-label label {\r\n        font-size: 14px; /* Adjust font size as needed */\r\n        color: #971b1b; /* Adjust color as needed */\r\n        cursor: pointer;\r\n      }\r\n      \r\n      /* choose file desgin */\r\n      .file-input {\r\n        /* Adjust the appearance of the file input button */\r\n        background-color: #4CAF50;\r\n        color: rgb(255, 255, 255);\r\n        padding: 10px 20px;\r\n        border: none;\r\n        border-radius: 5px;\r\n        \r\n      }\r\n      \r\n      .file-input:hover {\r\n        /* Adjust hover effect */\r\n        background-color: #4545a0;\r\n        cursor: pointer;\r\n      }\r\n      \r\n      /* ended master design */\r\n    \r\n           body {\r\n    \r\n                margin-top: 0px;\r\n            }\r\n    \r\n            .card-margin {\r\n                margin-bottom: 1.875rem;\r\n                \r\n            }\r\n           \r\n            .operator-container.card {\r\n                border: 0;\r\n                box-shadow: 0px 0px 10px 0px rgba(82, 63, 105, 0.1);\r\n                -webkit-box-shadow: 0px 0px 10px 0px rgba(82, 63, 105, 0.1);\r\n                -moz-box-shadow: 0px 0px 10px 0px rgba(82, 63, 105, 0.1);\r\n                -ms-box-shadow: 0px 0px 10px 0px rgba(82, 63, 105, 0.1);\r\n            }\r\n    \r\n            .operator-container .card {\r\n                position: relative;\r\n                display: flex;\r\n                flex-direction: column;\r\n                min-width: 0;\r\n                word-wrap: break-word;\r\n                background-color: #ffffff;\r\n                background-clip: border-box;\r\n                border: 1px solid #e6e4e9;\r\n                border-radius: 8px;\r\n            }\r\n    \r\n            .card card-header-operator .no-border {\r\n                border: 0;\r\n            }\r\n             \r\n        /* here we can adjust the header name left and right for first card*/\r\n        .card .card-header-operator1 {\r\n          background: none;\r\n          padding: 0 4.4375rem;\r\n          font-weight: 500;\r\n          display: flex;\r\n          align-items: center;\r\n          min-height: 50px;\r\n      }\r\n            /* here we can adjust the header name left to right second card*/\r\n            .card .card-header-operator {\r\n                background: none;\r\n                padding: 0 3.4375rem;\r\n                font-weight: 400;\r\n                display: flex;\r\n                align-items: center;\r\n                min-height: 50px;\r\n            }\r\n    \r\n            .card-header-operator:first-child {\r\n                border-radius: calc(8px - 1px) calc(8px - 1px) 0 0;\r\n            }\r\n            /* .card-title {\r\n              white-space: nowrap;\r\n              overflow: hidden;\r\n              text-overflow: ellipsis;\r\n              max-width: 140%;\r\n            } */\r\n            \r\n            \r\n            \r\n            .widget-49 .widget-49-title-wrapper {\r\n                display: flex;\r\n                align-items: center;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-primary {\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                flex-direction: column;\r\n                /* background-color: #edf1fc; */\r\n                width: 4rem;\r\n                height: 4rem;\r\n                border-radius: 50%;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-primary .widget-49-date-day {\r\n                color: #4e73e5;\r\n                font-weight: 500;\r\n                font-size: 1.5rem;\r\n                line-height: 1;\r\n                \r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-primary .widget-49-date-month {\r\n                color: #4e73e5;\r\n                line-height: 1;\r\n                font-size: 1rem;\r\n                text-transform: uppercase;\r\n                \r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-secondary {\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                flex-direction: column;\r\n                background-color: #fcfcfd;\r\n                width: 4rem;\r\n                height: 4rem;\r\n                border-radius: 50%;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-secondary .widget-49-date-day {\r\n                color: #dde1e9;\r\n                font-weight: 500;\r\n                font-size: 1.5rem;\r\n                line-height: 1;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-secondary .widget-49-date-month {\r\n                color: #dde1e9;\r\n                line-height: 1;\r\n                font-size: 1rem;\r\n                text-transform: uppercase;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-success {\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                flex-direction: column;\r\n                background-color: #e8faf8;\r\n                width: 4rem;\r\n                height: 4rem;\r\n                border-radius: 50%;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-success .widget-49-date-day {\r\n                color: #17d1bd;\r\n                font-weight: 500;\r\n                font-size: 1.5rem;\r\n                line-height: 1;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-success .widget-49-date-month {\r\n                color: #17d1bd;\r\n                line-height: 1;\r\n                font-size: 1rem;\r\n                text-transform: uppercase;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-info {\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                flex-direction: column;\r\n                background-color: #ebf7ff;\r\n                width: 4rem;\r\n                height: 4rem;\r\n                border-radius: 50%;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-info .widget-49-date-day {\r\n                color: #36afff;\r\n                font-weight: 500;\r\n                font-size: 1.5rem;\r\n                line-height: 1;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-info .widget-49-date-month {\r\n                color: #36afff;\r\n                line-height: 1;\r\n                font-size: 1rem;\r\n                text-transform: uppercase;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-warning {\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                flex-direction: column;\r\n                /* background-color: floralwhite; */\r\n                width: 4rem;\r\n                height: 4rem;\r\n                border-radius: 50%;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-warning .widget-49-date-day {\r\n                color: #FFC868;\r\n                font-weight: 500;\r\n                font-size: 1.5rem;\r\n                line-height: 1;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-warning .widget-49-date-month {\r\n                color: #FFC868;\r\n                line-height: 1;\r\n                font-size: 1rem;\r\n                text-transform: uppercase;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-danger {\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                flex-direction: column;\r\n                background-color: #feeeef;\r\n                width: 4rem;\r\n                height: 4rem;\r\n                border-radius: 50%;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-danger .widget-49-date-day {\r\n                color: #F95062;\r\n                font-weight: 500;\r\n                font-size: 1.5rem;\r\n                line-height: 1;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-danger .widget-49-date-month {\r\n                color: #F95062;\r\n                line-height: 1;\r\n                font-size: 1rem;\r\n                text-transform: uppercase;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-light {\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                flex-direction: column;\r\n                background-color: #fefeff;\r\n                width: 4rem;\r\n                height: 4rem;\r\n                border-radius: 50%;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-light .widget-49-date-day {\r\n                color: #f7f9fa;\r\n                font-weight: 500;\r\n                font-size: 1.5rem;\r\n                line-height: 1;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-light .widget-49-date-month {\r\n                color: #f7f9fa;\r\n                line-height: 1;\r\n                font-size: 1rem;\r\n                text-transform: uppercase;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-dark {\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                flex-direction: column;\r\n                background-color: #ebedee;\r\n                width: 4rem;\r\n                height: 4rem;\r\n                border-radius: 50%;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-dark .widget-49-date-day {\r\n                color: #394856;\r\n                font-weight: 500;\r\n                font-size: 1.5rem;\r\n                line-height: 1;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-dark .widget-49-date-month {\r\n                color: #394856;\r\n                line-height: 1;\r\n                font-size: 1rem;\r\n                text-transform: uppercase;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-base {\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                flex-direction: column;\r\n                background-color: #f0fafb;\r\n                width: 4rem;\r\n                height: 4rem;\r\n                border-radius: 50%;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-base .widget-49-date-day {\r\n                color: #68CBD7;\r\n                font-weight: 500;\r\n                font-size: 1.5rem;\r\n                line-height: 1;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-date-base .widget-49-date-month {\r\n                color: #68CBD7;\r\n                line-height: 1;\r\n                font-size: 1rem;\r\n                text-transform: uppercase;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-meeting-info {\r\n                display: flex;\r\n                flex-direction: column;\r\n                margin-left: 1rem;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-meeting-info .widget-49-pro-title {\r\n                color: #3c4142;\r\n                font-size: 14px;\r\n            }\r\n    \r\n            .widget-49 .widget-49-title-wrapper .widget-49-meeting-info .widget-49-meeting-time {\r\n                color: #B1BAC5;\r\n                font-size: 13px;\r\n            }\r\n    \r\n            .widget-49 .widget-49-meeting-points {\r\n                font-weight: 400;\r\n                font-size: 13px;\r\n                margin-top: .5rem;\r\n            }\r\n    \r\n            .widget-49 .widget-49-meeting-points .widget-49-meeting-item {\r\n                display: list-item;\r\n                color: #727686;\r\n            }\r\n    \r\n            .widget-49 .widget-49-meeting-points .widget-49-meeting-item span {\r\n                margin-left: .5rem;\r\n            }\r\n    \r\n            .widget-49 .widget-49-meeting-action {\r\n                text-align: center;\r\n            }\r\n    \r\n            .widget-49 .widget-49-meeting-action a {\r\n                text-transform: uppercase;\r\n            }\r\n            \r\n            button.btn.btn.btn-primary.btn-sm.btn-custom {\r\n                background-color: chocolate;\r\n                border: 1px solid chocolate;\r\n            }\r\n    \r\n            .content-push {\r\n                transition: margin-left 0.5s;\r\n              }\r\n              @media (min-width: 992px) {\r\n                .content-push {\r\n                  margin-left: 250px; /* Adjust as per your menu width */\r\n                }\r\n              }\r\n        /* ====== */\r\n       "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
